var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c360-what-is-new-modal',{attrs:{"enabled":_vm.enabled,"content":_vm.articleBody,"updatedAt":_vm.updatedAt},on:{"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }